export default __webpack_public_path__ + "static/media/004-distribution-4.a3f3404d.png";